<template>
  <div>
     <h1 :style="isMobile ? 'color:#fff; font-family:Guthen Bloots Personal Use, sans-serif; font-size: 55px;' : 
        'color:#fff; font-family:Guthen Bloots Personal Use, sans-serif; font-size: 70px;'">Premios</h1>   
     <br><br>
    <h6  style="color:#fff;  font-size: 19px;">
       “Tenemos espacios reservados en la Convención Comercial 2023 para los colaboradores de Canal Propio que obtengan el mayor puntaje al final del juego, apegados a los criterios de selección del concurso.” 
    </h6>
    <br>
    <h4 style="color:#29486F;"><b>Estructura General</b></h4>
    <br>
    <p  style="color:#fff;  font-size: 19px;">
        El juego consta de 4 ejes: logros, aceleradores, capacitación y desafíos.  <br><br>

        <b>Logros: </b> <br>
        relacionados con el cumplimiento de cuota. <br><br>

        <b>Capacitación:</b> <br>
        relacionados con su participación en los programas de capacitación. <br><br>
        
        <b>Desafíos:</b> <br>
        3 tipos de misiones: trivias, mini juegos y pistas ocultas.  Los participantes podrán ir completando las diferentes actividades con lo que irán sumando puntos. <br><br>

    </p>

        <h5 style="color:#29486F;"><b>LOGROS + CAPACITACIÓN + DESAFÍOS = Total de Puntos Acumulados por Participante.</b></h5> <br>
         <p  style="color:#fff;  font-size: 19px;">
            Los participantes podrán revisar su avance dentro de la plataforma del concurso.
         </p>  
    <br><br>
  </div>
</template>

<script>
export default {
 data(){
      return{
            isMobile: this.$mobile(),
      }
 },
 mounted()
  {
      if (this.isMobile)
      {
        this.$bus.$emit("cambi_fo6", true)
      } 
  }
}
</script>

<style>

</style>